(function () {
    'use strict';

    a3_pilot_reports.controller('LeaveRequestCtrl', LeaveRequestCtrl);

    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name LeaveRequestCtrl
    * @description 
    *   View Leave Request Tool
    * @ngInject
    */
    function LeaveRequestCtrl($route, $scope,$filter,LeaveRequestFactory,$uibModal, $timeout) {
      
        $scope.state = 'leaveRequest';
        $scope.getRandomBorderColor = getRandomBorderColor;
        $scope.getRandomTextColor = getRandomTextColor;
        $scope.IsValidLeaveRequest = IsValidLeaveRequest;
        $scope.showHelp = showHelp;
        
        $scope.showSuccessLeaveApplicationMessage = false;
        $scope.hasErrors = false;
        progressBarBox(true);
        LeaveRequestFactory.getConfigurationDetails(function(responseData){
           $scope.QualificationGroup = responseData.data.data.QualificationGroup;
           $scope.LeaveRequestInformation = responseData.data.data.LeaveRequestInformation;

           $scope.QualificationGroup.RequestLessDays = $scope.QualificationGroup.RequestLessDays ? $scope.QualificationGroup.RequestLessDays : false;
           $scope.QualificationGroup.RequestNoLeave = $scope.QualificationGroup.RequestNoLeave ? $scope.QualificationGroup.RequestNoLeave : false;
           

        if(responseData.data && responseData.data.data &&  responseData.data.data.QualificationGroup && responseData.data.data.LeaveRequestInformation ){
            //TEST
            //$scope.LeaveRequestInformation.GroupStatus = "PROCESS";
            
                $scope.closeDateStr = moment($scope.LeaveRequestInformation.CloseDate).format('Do of MMMM');
                $scope.isOpen =  $scope.LeaveRequestInformation.GroupStatus == "OPEN";
                $scope.LeaveRequest = {
                        YearId : $scope.LeaveRequestInformation.YearId,
                        MemberId : $scope.LeaveRequestInformation.MemberId,
                        RequestNoleave : responseData.data.data.LeaveRequest ? responseData.data.data.LeaveRequest.RequestNoleave : false, // Default: Request Leave selected
                        LeaveRequestSeasons : []   
                }

                if(responseData.data.data.LeaveRequest){
                    $scope.showSuccessLeaveApplicationMessage = true;
                }

               if(responseData.data.data.LeaveRequest && !responseData.data.data.LeaveRequest.RequestNoleave){
                   mergeRequest(responseData.data.data.LeaveRequest,$scope.QualificationGroup.Seasons);
               }else{
                   initializeNewRequest($scope.QualificationGroup.Seasons);
                   //Temporary: Hide Instructions
                    //if($scope.isOpen) $timeout(showHelp,500);
                   
               }
            }else
            {
                $scope.hasErrors = true;
            }
           progressBarBox(false);
        },function(data){
           $scope.hasErrors = true;
           progressBarBox(false);
        });
        
        function mergeRequest(leaveRequest,seasons){
            $scope.LeaveRequest = leaveRequest;
            for(var j=0;j<leaveRequest.LeaveRequestSeasons.length;j++){
             leaveRequest.LeaveRequestSeasons[j].HasSpecificCombinations = ($filter('filter')(leaveRequest.LeaveRequestSeasons[j].LeaveRequestPriorities, {Type: 'All'})).length>0;
                 
                 for(var i=0;i<seasons.length; i++ ){
                        if(seasons[i].Id == leaveRequest.LeaveRequestSeasons[j].SeasonId ){
                            leaveRequest.LeaveRequestSeasons[j].StartDate = seasons[i].StartDate;
                            leaveRequest.LeaveRequestSeasons[j].EndDate = seasons[i].EndDate;
                            leaveRequest.LeaveRequestSeasons[j].Slots = seasons[i].Slots;
                            leaveRequest.LeaveRequestSeasons[j].Configurations = seasons[i].Configurations;

                            setupMockLeaveRequestPriorities(leaveRequest.LeaveRequestSeasons[j].LeaveRequestPriorities,seasons[i].Slots);

                            for(var h=0; h<seasons[i].Configurations.length;h++){
                                if(seasons[i].Configurations[h].Id==leaveRequest.LeaveRequestSeasons[j].ConfigurationId ){
                                    leaveRequest.LeaveRequestSeasons[j].Configuration = seasons[i].Configurations[h];
                                }
                                
                            }
                            
                        }
                 }
            }

            $scope.LeaveRequest = leaveRequest;

        }
        
        function setupMockLeaveRequestPriorities(priorities,slots){
              for(var i=0;i< priorities.length; i++ ){
                   for(var j=0;j < priorities[i].LeaveRequestPriorityPeriods.length; j++ ){
                      for(var h=0; h<priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots.length; h++ )
                      {
                           var tempOrderNo = priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h].OrderNo;
                            //need clone the priority slot to fix conflicts with onder numbers
                           priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h] = JSON.parse(JSON.stringify(findSlot(priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h],slots)))
                           
                           if(priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h]){
                               priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots[h].OrderNo = tempOrderNo;
                           }
                      }
                      //need clone the priority slot to fix conflicts with onder numbers
                    priorities[i].LeaveRequestPriorityPeriods[j].MockLeaveRequestPrioritySlots =  JSON.parse(JSON.stringify(priorities[i].LeaveRequestPriorityPeriods[j].LeaveRequestPrioritySlots));
                   }
              }
            
        }
        
       function findSlot(value,slots){
           var temp = null;
           for(var i=0;i< slots.length; i++ ){
                if(slots[i].Id == value.Id){
                  temp =   slots[i];
                }
           }
          return temp;
       }
        
      function showHelp(){
         $uibModal.open({
                        templateUrl: 'views/LeaveRequest/dlgLeaveRequestInstructions.html',
                        controller: 'LeaveRequestInstructionsCtrl',
                        size: 'lg',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {}
                    })
        }
        
        
        function initializeNewRequest(seasons){
                for(var i=0;i<seasons.length; i++ ){
                    var leaveRequestSeason = seasons[i];

                    leaveRequestSeason.SeasonId = leaveRequestSeason.Id;
                    var flexLeaveRequestPriority = {
                        Type : "Any",
                        Priority: 1000,
                        LeaveRequestPriorityPeriods : []
                    };

                    var configurationDays = [];
                    for (var j=0; j < seasons[i].Configurations.length; j++){
                         configurationDays.push(seasons[i].Configurations[j].Days);
                    }
                    
                    leaveRequestSeason.Days =  configurationDays.unique();
                    leaveRequestSeason.HasSpecificCombinations = false;

                    
                    leaveRequestSeason.LeaveRequestPriorities = [flexLeaveRequestPriority];
                    $scope.LeaveRequest.LeaveRequestSeasons.push(leaveRequestSeason);     
                }
        }
        
        function IsValidLeaveRequest(){
            var isValid = true;
            if(!$scope.LeaveRequest.RequestNoleave){ //Validate only if Requested Leave
                if($scope.LeaveRequest && !$scope.invalidSelectedLeaveDays){
                    for(var i=0;i<$scope.LeaveRequest.LeaveRequestSeasons.length; i++ ){
                            for(var j=0;j<$scope.LeaveRequest.LeaveRequestSeasons[i].LeaveRequestPriorities.length; j++ ){
                                if($scope.LeaveRequest.LeaveRequestSeasons[i].LeaveRequestPriorities[j].HasInvalidPeriod){
                                    isValid= false;
                                    break;
                                }
                            }
    
                            if(!$scope.LeaveRequest.LeaveRequestSeasons[i].Configuration){
                                isValid = false;
                                break;
                            }
                    }
                }
                else
                {
                    isValid = false;
                }
            }
            return isValid;
        }
        
        
        $scope.updateLeaveRequestSeason = updateLeaveRequestSeason;
        $scope.showCombo=false;
        $scope.radioConfigurationModel = null;
        
        $scope.sendRequest = sendRequest;
        $scope.addComment = addComment;
        
        function addComment(request){
            request.Comments = " ";    
        } 
        
        function sendRequest() { 
            //Request No Leave: Clear any selected values
            if($scope.LeaveRequest.RequestNoleave){
                $scope.LeaveRequest.LeaveRequestSeasons = [];
            }
            progressBarBox(true);
            LeaveRequestFactory.saveLeaveRequest($scope.LeaveRequest,onSuccessSendRequest,onErrorSendRequest);
        }

        function onSuccessSendRequest(data){
            progressBarBox(false);
           
            if(data.data.success==true){
                ShowSuccessMessage()
            }else{
                ShowErrorMessage()
            }
        }
        
        function onErrorSendRequest(data){
             progressBarBox(false);
             ShowErrorMessage()
        }
        
        function ShowSuccessMessage(){
               var closeDateStr = moment($scope.LeaveRequestInformation.CloseDate).format('Do of MMMM');
               bootbox.alert({title : "<div class='text-green'>Success</div>",
                           message :"You have successfully submitted your leave request. You can modify your leave request untill the " + closeDateStr + ".",
                           callback: function(){ $route.reload(); }
                        });
        }
        
        function ShowErrorMessage(){
             bootbox.alert({title : "<div class='text-red'>Error</div>",
               message :"Failed to send your leave request. Please try again later",
               callback: function(){ $route.reload(); }
            });
        }
        
        function progressBarBox( isOpen ){
            if(isOpen){
                bootbox.dialog({
                    closeButton: false,
                    message: '<div class="text-center"><i class="fa fa-spin fa-spinner"></i> Please wait...</div>',
                    //title: "Please wait..."
                });
            }else {
                bootbox.hideAll();
            }

        }
        
/*        function setupView() {
            if (!UserFactory.isLoggedIn()) {
                $location.path("/login");
            }*/
  
         //$scope.sortableOptions['ui-floating'] = true;
        
        function updateLeaveRequestSeason(season){
            season.ConfigurationId = season.Configuration.Id
             for(var i=0;i<season.LeaveRequestPriorities.length; i++ ){
                
                for(var j=0;j<season.Configuration.Periods.length; j++ ){
                    season.Configuration.Periods[j].ConfigurationPeriodId = season.Configuration.Periods[j].Id
                }
                season.LeaveRequestPriorities[i].LeaveRequestPriorityPeriods= JSON.parse(JSON.stringify(season.Configuration.Periods));
             }
             var totalDays = 0; 
             
            var hasConfig = true;
            for (var i=0; i < $scope.LeaveRequest.LeaveRequestSeasons.length; i++){
                 totalDays = totalDays + (($scope.LeaveRequest.LeaveRequestSeasons[i].Configuration && $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration.Days) ? $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration.Days : 0);
                 hasConfig = hasConfig && $scope.LeaveRequest.LeaveRequestSeasons[i].Configuration;
             }
             if(totalDays > $scope.LeaveRequestInformation.LeaveDays){
                 $scope.invalidSelectedLeaveDays = true;
                bootbox.alert(("<h4 class='text-deep-orange'>Warning!</h4> You are entilted to <strong>" + $scope.LeaveRequestInformation.LeaveDays + " leave days </strong> but you have selected a combination of  <strong>" + totalDays + " days</strong>. Please proceed with the necessary changes.") 
				);
                 
             } else if (!$scope.QualificationGroup.RequestLessDays && (totalDays < $scope.LeaveRequestInformation.LeaveDays)){
                 $scope.invalidSelectedLeaveDays = true; 
                 if(hasConfig){
                     bootbox.alert(("<h4 class='text-deep-orange'>Warning!</h4> You are entilted to <strong>" + $scope.LeaveRequestInformation.LeaveDays + " leave days </strong> but you have selected a combination of  <strong>" + totalDays + " days</strong>. Please proceed with the necessary changes.") 
				    );
                }
             }
             else{
                 $scope.invalidSelectedLeaveDays = false;
             }
         
        }
        
        function getRandomBorderColor(season){
            var cssClass = "border-left-green"
            
            if(!season.Configuration){
                cssClass = "border-left-orange";
            }
            
            return cssClass;
        }
        
        function getRandomTextColor(season){
            var cssClass = "text-green"
            
            if(!season.Configuration){
                cssClass = "text-orange";
            }
            
            return cssClass;
        }
    }
    
    



})();